import cn from 'classnames';
import React from 'react';
import avatar from '../assets/stubs/avatar.png';
import IconFullStar from '../components/icon/IconFullStar';

type AvatarProps = {
  name: string
  url?: string
  className?: string
  rating?: number
}

/**
 * Avatar
 * @param name {string} Name of avatar's owner
 * @param url {string} Path to the avatar
 * @param className {string} Additional class names
 * @constructor
 */
export default function Avatar({
  name, url, className, rating,
}: AvatarProps) {
  const photo = url || avatar;
  return (
    <>
      <span className="inline-block relative">
        <img className={cn('rounded-md border border-gray-light', className)}
          src={photo}
          alt={name}/>
        {rating !== undefined && rating > 0 &&
        <div className="bg-green rounded text-white font-bold px-1 text-sm w-auto absolute -bottom-1.5 right-1">{rating} <IconFullStar/></div>}
      </span>
    </>
  );
}
